import { apiRequest } from './index';

export const saveScannedLetterRequest = async (letter_id, file) => {
	if (!letter_id || !file) {
		// TODO: Check if this error is working
		throw Object.assign(
			new Error('Some required params are missing'),
			{ error: 'missing_params' }
		 );
	}
	const formData = new FormData();
	formData.append('file', file);

	const end_point = `${process.env.REACT_APP_API_ENDPOINT}/api/admin/letters/save-letter-file/${letter_id}`;

	const response = await fetch(end_point, {
		method: 'POST',
		body: formData
	})

	const data = await response.json()
	return data;
}

export const uploadClientActionDocumentRequest = async (clientActionId, file) => {
	const formData = new FormData();
	  formData.append('file', file);
  
	  const end_point = `${process.env.REACT_APP_API_ENDPOINT}/api/admin/client-actions/save-document-file/${clientActionId}`;
  
	  const response = await fetch(end_point, {
		  method: 'POST',
		  body: formData
	  })
  
	  const data = await response.json()
	  return data;
}

export const uploadPaymentDocumentRequest = async (paymentIdsArray, file) => {

	try {
		const formData = new FormData()
		formData.append('file', file)

		const end_point = `${process.env.REACT_APP_API_ENDPOINT}/api/admin/payments/save-document-file/${paymentIdsArray[0]}`;
	
		const response = await fetch(end_point, {
			method: 'POST',
			body: formData
		})
	
		const data = await response.json()
		return data;
	
	} catch (error) {
		console.log("error", error)
	}
}

export const saveImagesArrayRequest = (product_id, data) => {
	return apiRequest(
		'/admin/products/save-image-array/' + product_id,
		{
			method: 'POST',
			body: JSON.stringify(data)
		}
	)
}

export const deleteImagesArrayRequest = (data) => {
	return apiRequest(
		'/admin/images/delete',
		{
			method: 'POST',
			body: JSON.stringify(data)
		}
	)
}